import { render, staticRenderFns } from "./notification-select.vue?vue&type=template&id=a1404718&scoped=true&"
import script from "./notification-select.vue?vue&type=script&lang=js&"
export * from "./notification-select.vue?vue&type=script&lang=js&"
import style0 from "./notification-select.vue?vue&type=style&index=0&id=a1404718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1404718",
  null
  
)

export default component.exports